export default {
    getUserCommentPost(state) {
        return state.userCommentPost;
    },
    getCommentCountPost(state) {
        return state.commentCountPost;
    }
};